/**
 * Chantier : - (securite, finding F-10)
 * Regle metier : (securite)
 * Decision : -
 * Neutralise les caracteres reserves de la grammaire PostgREST `.or()` (`,` `(` `)` separent et
 * groupent les conditions du logic tree) et les jokers/echappements ILIKE (`%` `_` `\`) dans une
 * chaine de recherche utilisateur interpolee dans un filtre `.or()`. Sans ce strip, une virgule ou
 * une parenthese saisie casse le logic tree (400 'failed to parse logic tree') et un `%`/`_` agit
 * comme joker. Recherche litterale. Retourne la chaine nettoyee + trim ; une chaine vide signifie
 * « ne pas appliquer de filtre de recherche ».
 */
export function escapePostgrestSearch(search: string): string {
  return search.trim().replace(/[%_,()\\]/g, '');
}
